function getWindowPosition(element: HTMLDivElement | HTMLElement) {
	if (!element)
		return {top: 0, left: 0, right: 0};

	const rect = element.getBoundingClientRect();
	const scrollTop = window?.pageYOffset || document?.documentElement?.scrollTop || 0;
	const scrollLeft = window?.pageXOffset || document?.documentElement?.scrollLeft || 0;

	return {
		top:   rect.top + scrollTop,
		left:  rect.left + scrollLeft,
		right: rect.right
	};
}

export {getWindowPosition};